/* SmartBliss 2026: se la ricerca di Shopify non restituisce prodotti, li cerca nel catalogo pubblico (products.json). */
(function () {
  const money = c => '€' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function card(p) {
    const prices = p.variants.map(v => Math.round(parseFloat(v.price) * 100));
    const real = prices.filter(c => c > 0), min = real.length ? Math.min(...real) : 0, compare = Math.max(...p.variants.map(v => Math.round(parseFloat(v.compare_at_price || 0) * 100)));
    const single = p.variants.length === 1;
    const img = p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=600' : '';
    const url = '/products/' + p.handle;
    const priceHtml = min === 0 ? '<div class="sb-price sb-price--store">Prezzo in negozio</div>'
      : `<div class="sb-price">${new Set(prices).size > 1 ? 'da ' : ''}${money(min)}${compare > min ? `<s>${money(compare)}</s>` : ''}</div>`;
    return `<div class="sb-card">
      <a href="${url}" class="sb-card__img">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
      ${compare > min ? '<span class="sb-tag">Offerta</span>' : '<span class="sb-tag sb-tag--none">·</span>'}
      <a href="${url}"><h3>${esc(p.title)}</h3></a>
      <div class="sb-card__buy">${priceHtml}<a class="sb-add" href="${url}">${min === 0 ? 'Dettagli' : single ? 'Vedi' : 'Scegli'}</a></div>
    </div>`;
  }

  async function run(box) {
    const words = norm(box.dataset.q).split(/\s+/).filter(w => w.length > 1);
    if (!words.length) return;
    const found = [];
    for (let page = 1; page <= 6; page++) {
      const res = await fetch(`/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const { products } = await res.json();
      products.forEach(p => {
        const hay = norm([p.title, p.vendor, p.product_type, (p.tags || []).join(' ')].join(' '));
        if (words.every(w => hay.includes(w))) found.push(p);
      });
      if (products.length < 250) break;
    }
    if (!found.length) return;
    const shown = found.slice(0, 48);
    box.querySelector('[data-sb-fallback-grid]').innerHTML = shown.map(card).join('');
    box.querySelector('[data-sb-fallback-count]').textContent = found.length === 1 ? '1 prodotto' : `${found.length} prodotti${found.length > shown.length ? ` · ne mostriamo ${shown.length}` : ''}`;
    box.hidden = false;
    const empty = box.closest('[data-sb-search]').querySelector('[data-sb-noresults]');
    if (empty) empty.hidden = true;
  }

  function boot() { document.querySelectorAll('[data-sb-fallback]:not([data-sb-ready])').forEach(b => { b.dataset.sbReady = ''; run(b).catch(() => {}); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
